import { Controller } from "@hotwired/stimulus"
import { csrfFetch, urlEncodeFormData } from "../lib/csrf_fetch"

// Submits the element's value to a URL on trigger (e.g. a shoelace switch or
// select change) and renders the turbo-stream response.
export default class extends Controller {
  static values = {
    url: String
  }

  submit(method, event) {
    let formData = new FormData()
    const { name, value } = event.currentTarget
    const url = this.urlValue

    if (name && !url.includes(`${name}=`)) { formData.append(name, value) }
    if (value) { formData.append("value", value) }

    csrfFetch(url, {
      method,
      headers: { "Accept": "text/vnd.turbo-stream.html" },
      body: urlEncodeFormData(formData)
    })
      .then(resp => resp.text())
      .then(html => window.Turbo.renderStreamMessage(html))
  }

  get(event) {
    this.submit("get", event)
  }

  post(event) {
    this.submit("post", event)
  }

  put(event) {
    this.submit("put", event)
  }

  delete(event) {
    this.submit("delete", event)
  }
}